const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';

const triggers = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.product-card',
  wishlistCounter: '[data-wishlist-count]'
};

document.addEventListener('DOMContentLoaded', () => {
  initButtons();
  initGrid();
  initCounter();
});

document.addEventListener('shopify-wishlist:updated', (event) => {
  initGrid();
  initCounter();
});

const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;
  return fetch(productTileTemplateUrl)
  .then((res) => res.text())
  .then((res) => {
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(res, 'text/html');
    const productCard = htmlDocument.documentElement.querySelector(triggers.productCard);
    if (!productCard) {
      console.warn(`[Shopify Wishlist] No ".product-card" found for handle: ${handle}. Check the "card" view template.`);
      return '';
    }
    return `<div class="col d-flex position-relative">${productCard.outerHTML}</div>`;
  })
  .catch((err) => {
    console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err);
    return '';
  });
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map((handle) => fetchProductCardHTML(handle));
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.filter(Boolean).join('');
  grid.innerHTML = wishlistProductCards;
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();

  const event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist: wishlist }
  });
  document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
    button.addEventListener('click', () => {
      updateWishlist(productHandle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
    });
  });
};

const initGrid = () => {
  const grid = document.querySelector(triggers.grid) || false;
  if (grid) setupGrid(grid);
};

const initButtons = () => {
  const buttons = document.querySelectorAll(triggers.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};

const setCounter = (counters) => {
  const wishlist = getWishlist();
  counters.forEach((counter) => {
     if (wishlist.length >= 1) counter.innerHTML = wishlist.length;
     else counter.innerHTML = '0';
  });
};

const initCounter = () => {
  const counters = document.querySelectorAll(triggers.wishlistCounter) || [];
  if (counters.length) setCounter(counters);
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (!wishlist) return [];
  const items = wishlist.split(LOCAL_STORAGE_DELIMITER)
    .map((h) => h.trim())
    .filter(Boolean);
  return [...new Set(items)];
};

const setWishlist = (array) => {
  const cleaned = [...new Set((array || []).map((h) => (h || '').trim()).filter(Boolean))];
  const wishlist = cleaned.join(LOCAL_STORAGE_DELIMITER);
  if (cleaned.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  const event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: cleaned }
  });
  document.dispatchEvent(event);

  return wishlist;
};

const updateWishlist = (handle) => {
  const cleanHandle = (handle || '').trim();
  if (!cleanHandle) return console.error('[Shopify Wishlist] Empty product handle — cannot update wishlist.');
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(cleanHandle);
  if (indexInWishlist === -1) wishlist.push(cleanHandle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes((handle || '').trim());
};

const resetWishlist = () => {
  return setWishlist([]);
};
